<template>
  <div class="account-page">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <!-- Account Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img
                      src="@/assets/img/login-banner.png"
                      class="img-fluid"
                      alt="Login Banner"
                    />
                  </div>
                  <div class="col-md-12 col-lg-5 login-right">
                    <div class="login-header">
                      <h3>Enter OTP</h3>
                      <p class="small text-muted">Enter your OTP No</p>
                    </div>

                    <!-- Forgot Password Form -->

                    <div class="form-group form-focus">
                      <input
                        class="form-control floating opt"
                        maxlength="6"
                        @keypress="onlyNumber"
                        v-model="otp"
                      />
                      <label class="focus-label">OTP No</label>
                    </div>
                    <div class="text-center" v-show="!resendOTP">
                      <p class="small text-muted">
                        Resend OTP in
                        <span>
                          <div id="countdown">
                            <div id="countdown-number"></div>
                            <svg>
                              <circle r="18" cx="20" cy="20"></circle>
                            </svg>
                          </div>
                        </span>
                        seconds
                      </p>
                    </div>
                    <div>
                      <router-link class="forgot-link" to="/forgot-password"
                        >Change Mobile No</router-link
                      >
                      <!-- <router-link
                        class="forgot-link"
                        style="margin-left: 153px"
                        to="/login-with-username"
                        >Login with Username</router-link
                      > -->
                    </div>

                    <div v-if="resendOTP">
                      <a
                        href="javascript:void(0);"
                        @click="resend_OTP()"
                        class="forgot-link"
                        >Resend OTP
                      </a>
                    </div>
                    <button
                      :disabled="!otp.match('[0-9]{6}')"
                      class="btn btn-primary btn-block btn-lg login-btn"
                      type="submit"
                      @click="verify_OTP()"
                    >
                      Verify OTP
                    </button>
                    <!-- </form> -->
                    <!-- /Forgot Password Form -->
                  </div>
                </div>
              </div>
              <!-- /Account Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>

<script>
import CommonApi from "../../services/CommonApi";
export default {
  props: ["mobile"],
  data() {
    return {
      resendOTP: false,
      cleartime: "",
      otp: "",
    };
  },
  watch: {
    resendOTP: function() {
      console.log("any of these variables changed");
    },
  },
  methods: {
    //Allow User to type number only
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    startCountDown() {
      var countdownNumberEl = document.getElementById("countdown-number");
      var countdown = 30;

      countdownNumberEl.textContent = countdown;

      this.cleartime = setInterval(function() {
        countdown = --countdown <= 1 ? 0 : countdown;
        countdownNumberEl.textContent = countdown;
      }, 1000);
    },

    stopCountDown(time) {
      var self = this;
      setTimeout(function() {
        clearInterval(self.cleartime);
        self.resendOTP = true;
      }, time);
    },

    resend_OTP() {
      this.otp = "";
      this.resendOTP = false;
      if (this.mobile) {
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.mobile);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (!res.status_code == 200) {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
      this.startCountDown();
      this.stopCountDown(30000);
    },
    verify_OTP() {
      if (this.mobile && this.otp) {
        this.$swal({
          text: "Verifying OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.mobile);
        bodyFormData.append("otp", this.otp);
        CommonApi.post_data(
          "sahaj.api.verify_otp_code",
          bodyFormData,
          true
        ).then((res) => {
          if (res.status_code == 200) {
            if (!res.data == false) {
              var userJson = {
                username: res.data.full_name,
                user: res.data.user,
                ...res.data.key_details,
              };
              localStorage.setItem("userInfo", JSON.stringify(userJson));
              this.$router.push("/change-password");
              this.$swal.close();
            } else {
              this.$swal.fire({
                icon: "error",
                title: "User Not Registered",
                text: "This Mobile Number Not Registered With Us",
                showConfirmButton: true,
              });
            }
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },
  },
  mounted() {
    this.startCountDown();
    this.stopCountDown(30000);
  },
  destroyed() {
    this.stopCountDown(0);
  },
};
</script>

<style scoped>
body {
  height: 100%;
  width: 100%;
  background-color: #333;
}

.opt {
  text-align: center;
  letter-spacing: 15px;
}

#countdown {
  position: relative;
  margin: auto;
  margin-top: 8px;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  color: black;
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: red;
  fill: none;
  animation: countdown 30s linear forwards;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }
  to {
    stroke-dashoffset: 113px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/kneexpert/EnterForgotPasswordOTP.vue